import { toast } from '@geerd-nx/ui';
import {
  useInsert_Block_OneMutation,
  Activity_LayoutDocument,
  Order_By,
  useInsert_Activity_Layout_OneMutation,
} from '@geerd-nx/shareable-graphql';
export function useSaveBlock(activityId: number) {
  const [createActivityLayout] = useInsert_Activity_Layout_OneMutation({
    update: (cache, { data }) => {
      cache.updateQuery(
        {
          query: Activity_LayoutDocument,
          variables: {
            where: { activityId: { _eq: activityId } },
            order_by: [{ order: Order_By.Asc }],
          },
        },
        (prev) => {
          return {
            ...prev,
            activity_layout: [
              ...prev.activity_layout,
              data?.insert_activity_layout_one,
            ],
          };
        }
      );
    },
  });
  const [createBlock] = useInsert_Block_OneMutation();
  const submitBlock = async ({
    order,
    size,
    type,
    columnNameType,
    name,
    blockToSaveId,
  }: {
    order: number;
    size: string;
    type: string;
    columnNameType: string;
    name: string;
    blockToSaveId: string | number;
  }) => {
    const result = await createBlock({
      variables: {
        object: {
          name,
          type,
          activityId,
          [columnNameType]: blockToSaveId,
        },
      },
    });
    const blockId = result.data?.insert_block_one?.id;
    if (blockId) {
      createActivityLayout({
        variables: {
          object: {
            order,
            blockId,
            activityId,
            size,
            type,
          },
        },
      });
    } else {
      toast.error('Error');
    }
  };
  return submitBlock;
}
